import tracker from '../../../analytics/tracker';
import ReactGA from 'react-ga4';

const CATEGORY = 'Onboarding';

const fireEvent = (action, properties = {}) => {
  tracker.event({ category: CATEGORY, action, properties });
  ReactGA.event({ category: CATEGORY, action, ...properties });
};

export const trackChecklistViewed = (completedCount, totalCount) =>
  fireEvent('onboarding_checklist_viewed', { completedCount, totalCount });

export const trackChecklistSkipped = (completedCount, totalCount) =>
  fireEvent('onboarding_checklist_skipped', { completedCount, totalCount });

export const trackTourStarted = (tourId, totalSteps) =>
  fireEvent('onboarding_tour_started', { tourId, totalSteps });

export const trackTourStepViewed = (tourId, stepIndex, stepId) =>
  fireEvent('onboarding_tour_step_viewed', { tourId, stepIndex, stepId });

export const trackTourCompleted = (tourId, totalSteps, durationMs) =>
  fireEvent('onboarding_tour_completed', { tourId, totalSteps, durationMs });

export const trackTourAbandoned = (tourId, lastStep, totalSteps, durationMs) =>
  fireEvent('onboarding_tour_abandoned', { tourId, lastStep, totalSteps, durationMs });

export const trackAllCompleted = (method, totalDurationMs) =>
  fireEvent('onboarding_all_completed', { method, totalDurationMs });
